
import React from 'react'
import { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import { IoMdDownload } from "react-icons/io";

import ToastNotification from '../../../components/ToastNotification';
import axios from 'axios'
import { Modal, Button, Row, Col, Table } from "react-bootstrap";
import { FaWhatsapp } from "react-icons/fa6";

import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { TbPasswordUser } from "react-icons/tb";



const AddEmployee = () => {
    const [page, setPage] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [previews, setPreviews] = useState({});

    const [user, setUser] = useState([]);
    const [editSubjectId, setEditSubjectId] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [selectedEmp, setSelectedEmp] = useState(null);
    const [department, setDepartment] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [roles, setRoles] = useState([]);
    const [selectedRoleId, setSelectedRoleId] = useState('');
    const [companyID, setCompanyID] = useState(() => localStorage.getItem('companyID') || '');
    const previousCompanyID = useRef(companyID);

    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [regionOptions, setRegionOptions] = useState([]);
    const [pincodeOptions, setPincodeOptions] = useState([]);
    const [showDesignationModal, setShowDesignationModal] = useState(false);
    const [newDesignationName, setNewDesignationName] = useState("");
    const [designationOptions, setDesignationOptions] = useState([]);

    const [reportingOptions, setReportingOptions] = useState([]);
   const [showReportingModal, setShowReportingModal] = useState(false);
    const [newReportingName, setNewReportingName] = useState("");

    const [searchTerm, setSearchTerm] = useState('');
    const [branches, setBranches] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const handleAddClick = () => {
        setSelectedRoleId('');
        setShowForm(true);
    };
    const [isEditMode, setIsEditMode] = useState(false);
    const [showPasswordModal, setShowPasswordModal] = useState(false); 
const [currentEmp, setCurrentEmp] = useState(null);                 
const [enteredPassword, setEnteredPassword] = useState("");        
       const [detail, setDetail] = useState([]);

    const [form, setForm] = useState({
        title: '',
        first: '',
        middle: '',
        last: "",
        emp_id: "",
        emp_code: '',
        phone: '',
        extension: '',
        email: '',
        dob: '',
        confirmed: '',
        gender: '',
        job_status: '',
        designation: '',
        department: '',
        address: '',
        city: '',
        pin: '',
        state: '',
        bank_name: '',
        bank_acc: '',
        bank_branch: '',
        ifsc: '',
        esic: '',
        reporting: '',
        weekly_off: '',
        basic: '',
        marital_status: '',
        doj: '',
        seperation_date: '',
        pf_no: '',
        alt_first: '',
        alt_second: '',
        region: '',
        lic: "",
        mediclaim_no: '',
        role: '',
        branch: '',

        medical_info: '',
        medical_condition: '',
        blood_grp: '',
        alergies: '',
        phoneChecked: false,
        phoneChecked_one:false,
        phoneChecked_two:false,

        pincode_two:'',
        state_two:'',
        city_two:'',
        region_two:'',
        address_two:'',

        
    });

    const [rows, setRows] = useState([
        {
            employer: "",
            designation: "",
            doj: "",
            leftOn: "",
            joiningSalary: "",
            lastSalary: "",
        },
    ]);

    const [educationRows, setEducationRows] = useState([
        {
            exam: "",
            board: "",
            passingYear: "",
            percentage: "",
            certificate: null,
        },
    ]);

    const [members, setMembers] = useState([
        { name: "", relation: "", contact: "", work: "" },
    ]);

    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };


    const downloadAll = async (empId, firstName, lastName) => {
        try {
            const response = await fetch(`https://api.skyguard.group/api/download-employee/${empId}`, {
                method: 'GET',
            });
            if (!response.ok) throw new Error('Failed to download PDF');

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `${firstName}_${lastName}.pdf`; 
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

        } catch (err) {
            console.error(err);
            showToast('Error downloading PDF ', 'danger');
        }
    };


    const statusOptions = [
        { value: '1', label: 'Permanent' },
        { value: '2', label: 'Temporary' },
        { value: '3', label: 'Other' }
    ];

    const titleOptions = [
        { value: '1', label: 'Mrs.' },
        { value: '2', label: 'Mr.' },
        { value: '3', label: 'Ms.' },
    ]


    const departmentOptions = [
        { value: '1', label: 'Sales' },
        { value: '2', label: 'Technical' },
        { value: '3', label: 'Other' }
    ]

    const genderOptions = [
        { value: '1', label: 'Male' },
        { value: '2', label: 'Female' },
        { value: '3', label: 'Other' }
    ]
  
    const maritalOptions = [
        { value: '1', label: 'Married' },
        { value: '2', label: 'Unmarried' },
    ]
    const weekOptions = [
        { value: '1', label: 'Monday' },
        { value: '2', label: 'Tuesday' },
        { value: '3', label: 'Wednesday' },
        { value: '4', label: 'Thursday' },
        { value: '5', label: 'Friday' },
        { value: '6', label: 'Saturday' },
        { value: '7', label: 'Sunday' },
    ]

    const cities = ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix'];
    const states = ['California', 'Texas', 'Florida', 'New York', 'Illinois'];
    const regions = ['Region1', 'Regions2', 'Regions3']

    const [presentAddress, setPresentAddress] = useState({
        address: '',
        city: '',
        pin: '',
        state: '',
    });

    const [permanentAddress, setPermanentAddress] = useState({
        address: '',
        city: '',
        pin: '',
        state: '',
    });

    const [sameAsPresent, setSameAsPresent] = useState(false);

    const handlePresentChange = (e) => {
        const { name, value } = e.target;
        setPresentAddress((prev) => ({ ...prev, [name]: value }));
    };

    const handlePermanentChange = (e) => {
        const { name, value } = e.target;
        setPermanentAddress((prev) => ({ ...prev, [name]: value }));
    };



    const handleCheckboxChange = () => {
        const newChecked = !sameAsPresent;
        setSameAsPresent(newChecked);

        if (newChecked) {
            // Auto-fill permanent address with present address
            setPermanentAddress({ ...presentAddress });
        } else {
        
            setPermanentAddress({ state: "", city: "", region: "", pincode: "" });
        }
    };


    const handleAddRow = () => {
        setRows([
            ...rows,
            {
                employer: "",
                designation: "",
                doj: "",
                leftOn: "",
                joiningSalary: "",
                lastSalary: "",
            },
        ]);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
            ...(isEditMode && name === "phone" ? { phoneChecked: false } : {}),
            ...(isEditMode && name === "alt_first"? {phoneChecked_one :false} :{}),
            ...(isEditMode && name === "alt_second" ? {phoneChecked_two :false} : {} ),
        }));
    };

    const handleSelectChange = (selectedOption, actionMeta) => {
        setForm((prev) => ({
            ...prev,
            [actionMeta.name]: selectedOption.value, 
        }));
    };


    const handleAddEducationRow = () => {
        setEducationRows([
            ...educationRows,
            {
                exam: "",
                board: "",
                passingYear: "",
                percentage: "",
                certificate: null,
            },
        ]);
    };

  
    const handleDeleteEducationRow = (index) => {
        const updated = educationRows.filter((_, i) => i !== index);
        setEducationRows(updated);
    };

  
    const handleEducationChange = (index, field, value) => {
        const updated = [...educationRows];
        updated[index][field] = value;
        setEducationRows(updated);
    };


    const handleFileRowChange = (index, file) => {
        const updated = [...educationRows];
        updated[index].certificate = file;
        setEducationRows(updated);
    };


    const handleAddMemberRow = () => {
        setMembers([...members, { name: "", relation: "", contact: "", work: "" }]);
    };


    const handleDeleteMemberRow = (index) => {
        const updated = members.filter((_, i) => i !== index);
        setMembers(updated);
    };


    const handleMemberChange = (index, field, value) => {
        const updated = [...members];
        updated[index][field] = value;
        setMembers(updated);
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeInMB = file.size / (1024 * 1024);
            if (fileSizeInMB > 5) {
                showToast('File is too large please upload file less then 5 MB  !', 'danger');
                e.target.value = "";
                return;
            }

            setFiles((prevFiles) => ({
                ...prevFiles,
                [e.target.name]: file,
            }));
        }
        setFiles((prevFiles) => ({
            ...prevFiles,
            [e.target.name]: file,
        }));
    }


    const [files, setFiles] = useState({
        file: null,
        pan: null,
        aadhaar: null,
        light_bill: null,
        tenth_mark: null,
        twelth_mark: null,
        other_doc: null

    });
    const handleDeleteRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
    };


    const handleChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const fileFields = [
        "file",
        "pan",
        "aadhaar",
        "light_bill",
        "tenth_mark",
        "twelth_mark",
        "other_doc"
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isEditMode) {
            const currentCompanyID = localStorage.getItem('companyID') || '';
            if (currentCompanyID !== companyID) {
                setCompanyID(currentCompanyID);
                showToast('Company changed. Select a role for the current company before adding the employee.', 'warning');
                return;
            }
            const selected = roles.find(role => String(role.value) === String(selectedRoleId));
            const branch = branches.find(item => String(item.id) === String(form.branch));
            if (!selected || selected.department !== form.department || selected.roleText !== form.role || !branch ||
                Number(selected.company_id) !== Number(branch.company_id)) {
                showToast('Select a branch and an existing role for its company before adding the employee.', 'warning');
                return;
            }
        }

        if (isEditMode) {

            const formData = new FormData();
            fileFields.forEach((key) => {
                if (files[key] instanceof File) {
                    formData.append(key, files[key]);
                }
            });

            Object.keys(form).forEach((key) => {

                if (key === "phoneChecked" || key ==="phoneChecked_one" || key === 'phoneChecked_two') {
                    formData.append(key, form[key] ? 1 : 0);
                } else {
                    formData.append(key, form[key]);
                }
            });

            formData.append("employment_history", JSON.stringify(rows));
            formData.append(
                "education_details",
                JSON.stringify(
                    educationRows.map((e) => ({
                        ...e,
                        certificate: e.certificate ? e.certificate.name : null,
                    }))
                )
            );
            formData.append("family_members", JSON.stringify(members));


            try {
                const res = await axios.put(
                    `https://api.skyguard.group/api/update-employee/${form.id}`,
                    formData,
                    {
                        headers: { "Content-Type": "multipart/form-data" },
                    }
                );
          
                showToast('Employee Updated successfully!', 'success');
                fecthDetail();
                setShowForm(false);
                setSelectedRoleId('');
                setForm({
                    title: '', first: '', middle: '', last: '',
                    emp_id: '', emp_code: '', phone: '', extension: '',
                    email: '', dob: '', confirmed: '', gender: '', job_status: '',
                    designation: '', department: '', address: '', city: '',
                    pin: '', state: '', bank_name: '', bank_acc: '', bank_branch: '',
                    ifsc: '', esic: '', reporting: '', weekly_off: '', basic: '',
                    marital_status: '', doj: '', seperation_date: '', pf_no: '',
                    role: '', region: '', alt_first: '', alt_second: '',
                    lic: '', mediclaim_no: '', branch: '', medical_info: '',
                    medical_condition: '',
                    blood_grp: '',
                    alergies: '',
                });

                setRows([]);
                setMembers([]);
                setEducationRows([]);

            } catch (err) {
                console.error(err.response?.data || err.message);
                showToast('Fail to updated Employee !', 'danger');
            }


        } else {
        

            const sendData = new FormData();

            sendData.append("title", form.title);
            sendData.append("first", form.first);
            sendData.append("middle", form.middle);
            sendData.append("last", form.last);
            // sendData.append("emp_id", form.emp_id);
            // sendData.append("emp_code", form.emp_code);
            sendData.append("phone", form.phone);
            sendData.append("extension", form.extension);

            sendData.append("email", form.email);
            sendData.append("dob", form.dob);
            sendData.append("confirmed", form.confirmed);
            sendData.append("gender", form.gender);
            sendData.append("job_status", form.job_status);
            sendData.append("designation", form.designation);
            sendData.append("department", form.department);
            sendData.append("address", form.address);
            sendData.append("city", form.city);
            sendData.append("pin", form.pin);
            sendData.append("state", form.state);
            sendData.append("bank_name", form.bank_name);
            sendData.append("bank_acc", form.bank_acc);
            sendData.append("bank_branch", form.bank_branch);
            sendData.append("ifsc", form.ifsc);
            sendData.append("esic", form.esic);
            sendData.append("reporting", form.reporting);
            sendData.append("weekly_off", form.weekly_off);
            sendData.append("basic", form.basic);
            sendData.append("marital_status", form.marital_status);
            sendData.append("doj", form.doj);
            sendData.append("seperation_date", form.seperation_date);
            sendData.append('pf_no', form.pf_no);

            sendData.append('alt_first', form.alt_first);
            sendData.append('alt_second', form.alt_second);
            sendData.append('region', form.region);
            sendData.append('lic', form.lic);
            sendData.append('mediclaim_no', form.mediclaim_no);
            sendData.append('role', form.role);
            sendData.append('initial_role_id', selectedRoleId);
            sendData.append('branch', form.branch);
            sendData.append('medical_info', form.medical_info);
            sendData.append('medical_condition', form.medical_condition);
            sendData.append('blood_grp', form.blood_grp);
            sendData.append('alergies', form.alergies);
             sendData.append('phoneChecked', form.phoneChecked);
             sendData.append('phoneChecked_one',form.phoneChecked_one);
             sendData.append('phoneChecked_two',form.phoneChecked_two);

             sendData.append('pincode_two',form.pincode_two);
             sendData.append('state_two',form.state_two);
             sendData.append('city_two',form.city_two);
             sendData.append('region_two',form.region_two);
             sendData.append('address_two',form.address_two);

            Object.keys(files).forEach((key) => {
                if (files[key] instanceof File) {  
                    sendData.append(key, files[key]);
                }
            });

            sendData.append("employment_history", JSON.stringify(rows));
            sendData.append("education_details", JSON.stringify(educationRows.map(e => ({
                ...e,
                certificate: e.certificate ? e.certificate.name : null
            }))));
            sendData.append("family_members", JSON.stringify(members));


            try {
                const res = await axios.post(
                    "https://api.skyguard.group/api/add-employee",
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                setShowForm(false);
                showToast('Employee Added successfully!', 'success');
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
                showToast('Fail to added Employee  !', 'danger');
            }

        }
        fecthDetail();
        setShowForm(false);
        setIsEditMode(false);
        setSelectedRoleId('');
        setForm({
            title: '', first: '', middle: '', last: '',
            emp_id: '', emp_code: '', phone: '', extension: '',
            email: '', dob: '', confirmed: '', gender: '', job_status: '',
            designation: '', department: '', address: '', city: '',
            pin: '', state: '', bank_name: '', bank_acc: '', bank_branch: '',
            ifsc: '', esic: '', reporting: '', weekly_off: '', basic: '',
            marital_status: '', doj: '', seperation_date: '', pf_no: '',
            role: '', region: '', alt_first: '', alt_second: '',
            lic: '', mediclaim_no: '', branch: '', medical_info: '',
            medical_condition: '', blood_grp: '',alergies: '',pincode_two:'', state_two:'', city_two:'',  region_two:'', address_two:'',
        });
        setFiles({});
        setRows([]);
        setMembers([]);
        setEducationRows([]); 


    };


    const handleEdit = (emp) => {
        setSelectedRoleId('');

        setForm({
            id: emp.id || '',
            title: emp.title || '',
            first: emp.first || '',
            middle: emp.middle || '',
            last: emp.last || '',
            emp_id: emp.emp_id || '',
            emp_code: emp.emp_code || '',
            phone: emp.phone || '',
            extension: emp.extension || '',
            email: emp.email || '',
            dob: emp.dob || '',
            confirmed: emp.confirmed || '',
            gender: emp.gender || '',
            job_status: emp.job_status || '',
            designation: emp.designation || '',
            department: emp.department || '',
            address: emp.address || '',
            city: emp.city || '',
            pin: emp.pin || '',
            state: emp.state || '',
            bank_name: emp.bank_name || '',
            bank_acc: emp.bank_acc || '',
            bank_branch: emp.bank_branch || '',
            ifsc: emp.ifsc || '',
            esic: emp.esic || '',
            reporting: emp.reporting || '',
            weekly_off: emp.weekly_off || '',
            basic: emp.basic || '',
            marital_status: emp.marital_status || '',
            doj: emp.doj || '',
            seperation_date: emp.seperation_date || '',
            pf_no: emp.pf_no || '',
            alt_first: emp.alt_first || '',
            alt_second: emp.alt_second || '',
            region: emp.region || '',
            lic: emp.lic || "",
            mediclaim_no: emp.mediclaim_no || '',
            role: emp.role || '',
            branch: emp.branch || '',
            medical_info: emp.medical_info || '',
            medical_condition: emp.medical_condition || '',
            blood_grp: emp.blood_grp || '',
            alergies: emp.alergies || '',
            phoneChecked: emp.phoneChecked || false,
            phoneChecked_one:emp.phoneChecked_one || false,
            phoneChecked_two:emp.phoneChecked_two || false,

            pincode_two:emp.pincode_two || '',
            state_two:emp.state_two || "",
            city_two:emp.city_two || '',
            region_two:emp.region_two || '',
            address_two:emp.address_two || "",
        });


        setFiles({
            file: emp.photo || "",
            aadhaar: emp.aadhaar || null,
            pan: emp.pan || null,
            light_bill: emp.light_bill || null,
            tenth_mark: emp.tenth_mark || null,
            twelth_mark: emp.twelth_mark || null,
            other_doc: emp.other_doc || null,

        });



        const safeParse = (data) => {
            try {
                return data ? JSON.parse(data) : [];
            } catch (err) {
                console.warn("Invalid JSON data:", data, err);
                return []; // fallback to empty array
            }
        };

        setRows(safeParse(emp.employment_history));

        setMembers(safeParse(emp.family_members));

        setEducationRows(
            safeParse(emp.education_details).map(row => ({
                ...row,
                certificate: row.certificate || null,
            }))
        );

        setEditSubjectId(emp.id);
        setIsEditMode(true);
        setShowForm(true);
    };



const fecthDetail = async () => {
    try {
        const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');

        const rawList = resEmployee.data.result || [];
        const employees = rawList
            .filter(emp => emp && (emp.emp_id != null || emp.emp_code != null))
            .sort((a, b) => (Number(b.id) || 0) - (Number(a.id) || 0));
        setUser(employees);
        const uniqueDesignations = [
            ...new Set(employees.map(emp => emp.designation).filter(Boolean))
        ];


        const options = uniqueDesignations.map(d => ({
            label: d,
            value: d.toLowerCase().replace(/\s+/g, "_")
        }));

        setDesignationOptions(options);

         const uniqueReporting = [
            ...new Set(employees.map(emp => emp.reporting).filter(Boolean))
        ];

       setReportingOptions(
        uniqueReporting.map( r => ( {
            label:r,
            value:r.toLowerCase().replace(/\s+/g, "_")
        }))
       )

        localStorage.setItem('empData', JSON.stringify(employees));

    } catch (error) {
        console.log(error)
    }
};

    useEffect(() => {

        fecthDetail();
        fetchStateDetail();
        fecthBranchDetail();
    }, []);


    const handleDeleteEmployee = async (id) => {

        try {
            const res = await axios.delete(`https://api.skyguard.group/api/delete-employee/${id}`);

            showToast('Employee deleted successfully!', 'success');
            fecthDetail();

        } catch (err) {
            console.error(err.response?.data || err.message);
            showToast('Failed to delete employee!', 'danger');
        }
    };



    useEffect(() => {
        const syncCompany = () => setCompanyID(localStorage.getItem('companyID') || '');
        window.addEventListener('storage', syncCompany);
        window.addEventListener('focus', syncCompany);
        const interval = setInterval(syncCompany, 1000);
        return () => {
            clearInterval(interval);
            window.removeEventListener('storage', syncCompany);
            window.removeEventListener('focus', syncCompany);
        };
    }, []);

    useEffect(() => {
        let live = true;
        if (previousCompanyID.current !== companyID) {
            setSelectedRoleId('');
            setForm(previous => ({ ...previous, department: '', role: '' }));
        }
        previousCompanyID.current = companyID;
        setDepartments([]);
        setRoles([]);
        const fetchRoleDetail = async () => {
        try {
            const res = await axios.get("https://api.skyguard.group/api/fetch-role", { params: companyID ? { company_id: companyID } : {} });
            if (!live) return;
            const result = res.data.result || [];

         
            const uniqueDepartments = [
                ...new Set(result.map((item) => item.department)),
            ];
            const deptOptions = uniqueDepartments.map((dept) => ({
                value: dept,
                label: dept,
            }));


            const roleOptions = result.map((item) => ({
                value: item.id,
                roleText: item.role,
                company_id: item.company_id,
                label: item.role,
                department: item.department, 
            }));

            setDepartments(deptOptions);
            setRoles(roleOptions);
        } catch (error) {
            if (live) console.error(error);
        }
        };
        fetchRoleDetail();
        return () => { live = false; };
    }, [companyID]);



    const fetchStateDetail = async () => {
        try {
            const res = await axios.get("https://api.skyguard.group/api/fetch-state");
            const result = res.data.result || [];

            const uniqueStates = [...new Set(result.map((item) => item.state))];
            const uniqueCities = [...new Set(result.map((item) => item.city))];
            const uniqueRegions = [...new Set(result.map((item) => item.region))];
            const uniquePincodes = [...new Set(result.map((item) => item.pincode))];

            setStateOptions(uniqueStates);
            setCityOptions(uniqueCities);
            setRegionOptions(uniqueRegions);
            setPincodeOptions(uniquePincodes);
        } catch (error) {
            console.error(error);
        }
    };





    const documents = selectedEmp
        ? [
            { label: "PAN", file: selectedEmp.pan },
            { label: "Aadhaar", file: selectedEmp.aadhaar },
            { label: "Light Bill", file: selectedEmp.light_bill },
            { label: "10th Marksheet", file: selectedEmp.tenth_mark },
            { label: "12th Marksheet", file: selectedEmp.twelth_mark },
            { label: "Other Document", file: selectedEmp.other_doc },
        ]
        : [];

    const handleView = (emp) => {
        setSelectedEmp(emp);
        setPage(1); 

        setShowModal(true);
    };

    const downloadFile = (fileName) => {
      
        window.open(`https://api.skyguard.group/uploads/${fileName}`, "_blank");
    };

    const filterUser = user.filter((tt) => {
        const term = (searchTerm || '').trim().toLowerCase();
        if (!term) return true;

        return (
            (tt.first && tt.first.toLowerCase().includes(term)) ||
            (tt.middle && tt.middle.toLowerCase().includes(term)) ||
            (tt.last && tt.last.toLowerCase().includes(term)) ||
            (tt.emp_code && tt.emp_code.toString().toLowerCase().includes(term)) ||
            (tt.phone && tt.phone.toString().toLowerCase().includes(term)) ||
            (tt.emp_id && tt.emp_id.toString().toLowerCase().includes(term)) ||
            (tt.email && tt.email.toLowerCase().includes(term))
        );
    });

    const fecthBranchDetail = async () => {
        try {
            const resBranch = await axios.get('https://api.skyguard.group/api/fetch-branch');
            setBranches(resBranch.data.result);
        } catch (error) {
            console.log(error)
        }
    };


    const handlePincodeCheck = async () => {
        try {
            const response = await axios.get(
                `https://api.skyguard.group/api/check?pincode=${form.pin}`
            );

            const data = response.data;
            setForm({
                ...form,
                city: data.city,
                state: data.state,
                region: data.region
            });
        } catch (error) {


            if (error.response && error.response.status === 404) {
                showToast("❌ Pincode not found !", 'danger');
            } else {
                showToast("⚠️ Something went wrong while checking the pincode.", 'danger');
            }
            console.error("Error checking pincode:", error);
            setForm({
                ...form,
                city: "",
                state: "",
                region: ""
            });
        }
    };


     const handlePincodeCheckParmanent = async () => {
        try {
            const response = await axios.get(
                `https://api.skyguard.group/api/checkPermanent?pincode=${form.pincode_two}`
            );

            const data = response.data;


            setForm({
                ...form,
                city_two: data.city_two,
                state_two: data.state_two,
                region_two: data.region_two
            });
        } catch (error) {


            if (error.response && error.response.status === 404) {
                showToast("❌ Pincode not found !", 'danger');
            } else {
                showToast("⚠️ Something went wrong while checking the pincode.", 'danger');
            }
            console.error("Error checking pincode:", error);
            setForm({
                ...form,
                city_two: "",
                state_two: "",
                region_two: ""
            });
        }
    };

    const handleUpdatePassword = async () => {
    if (!enteredPassword) {
        // alert("Please enter a password");
        showToast('Please enter a password!', 'warning');
        return;
    }

    try {
      const res =  await axios.put("https://api.skyguard.group/api/update-password", {
            empId: currentEmp.id,
            password: enteredPassword
        });

        setShowPasswordModal(false);
        setEnteredPassword("");
        setCurrentEmp(null);

        fecthDetail();
       showToast('Password updated successfully!', 'success');

    } catch (err) {
        console.error(err);
            showToast('Failed to update password!', 'danger');
    }
};

    return (
        <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />



                <h3 className='my-3 fw-bold fs-5 golos'>Add Employee </h3>
                {/* Search + Add */}
                <div class="mb-3 row gx-3 gy-2 align-items-center  d-flex justify-content-between">
                    <div class="col-12 col-md-4">
                        <input
                            type="text"
                            class="form-control"
                             autoComplete="off"
                         
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search by Employee Name, ID,Phone..."
                        />
                    </div>
                    <div className="col-12 col-md-2 d-flex justify-content-end">
                        <button className='btn btn-success' onClick={handleAddClick} >
                            <AiOutlinePlusCircle size={20} /> Add 
                        </button>
                    </div>
                </div>
                {/* form */}
                {showForm && (


                    <div className='card p-3 mb-3'>
                        <form onSubmit={handleSubmit} >

                            <h5 className="mt-1 fs-4 text-center fw-semibold text-primary">Basic Info</h5>
                     {isEditMode && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {form.emp_id}
    </span>
  </div>
)}
                            <hr />

                            <div className='row g-3'>
                                {/* Title */}
                                <div className="col-md-4">
                                    <label htmlFor="title" className="form-label fw-medium">Select Title</label>

                                    <Select
                                        options={titleOptions}
                                        placeholder="Choose Title..."
                                        id="title"
                                        value={titleOptions.find(option => option.label === form.title)}
                                        onChange={(selectedOption) =>
                                            setForm({ ...form, title: selectedOption.label })
                                        }
                                    />

                                </div>
                                {/* First Name */}
                                <div className="col-md-4">
                                    <label htmlFor='name' className="form-label fw-medium" >First Name</label>
                                    <input type="text" className="form-control" name="first" placeholder="Enter here..." value={form.first} onChange={handleInputChange} required />
                                </div>
                                {/* Middle Name */}
                                <div className="col-md-4">
                                    <label htmlFor='middle' className="form-label fw-medium" >Middle Name</label>
                                    <input type="text" className="form-control" name="middle" placeholder="Enter here..."
                                        value={form.middle}
                                        onChange={handleInputChange}

                                    />
                                </div>
                                {/* Last Name */}
                                <div className="col-md-4">
                                    <label htmlFor='last' className="form-label fw-medium" >Last Name</label>
                                    <input type="text" className="form-control" name="last" placeholder="Enter here..."
                                        value={form.last}
                                        onChange={handleInputChange}
                                    />
                                </div>



                                <div className="col-md-4">
                                    <label htmlFor="phone" className="form-label fw-medium mb-0">Phone No.</label>

                                    {/* Phone input */}
                                    <input
                                        type="number"
                                        className="form-control mt-1"
                                        name="phone"
                                        placeholder="Enter here..."
                                        value={form.phone}
                                        onChange={handleInputChange}
                                        required
                                        maxLength={10}
                                    />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="form-check mb-0">


                                            <div className="d-flex justify-content-between align-items-center">



                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="phoneCheckbox"
                                                        checked={form.phoneChecked}
                                                        onChange={(e) => setForm({ ...form, phoneChecked: e.target.checked })}
                                                    />
                                                    <FaWhatsapp size={20} className='text-success' />
                                                    <label className="form-check-label small" htmlFor="phoneCheckbox">

                                                    </label>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>



                                <div className="col-md-4">
                                    <label htmlFor='extension' className="form-label fw-medium"  >First Alternate No.</label>
                                    <input type="text" className="form-control" name="alt_first" placeholder="Enter here..."
                                        value={form.alt_first}
                                        onChange={handleInputChange}
                                    />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="form-check mb-0">

                                          
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="form-check mb-0">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="phoneCheckbox"
                                                            checked={form.phoneChecked_one}
                                                            onChange={(e) => setForm({ ...form, phoneChecked_one: e.target.checked })}
                                                        />
                                                        <FaWhatsapp size={20} className='text-success' />
                                                        <label className="form-check-label small" htmlFor="phoneCheckbox">

                                                        </label>
                                                    </div>

                                                </div>
                                         
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <label htmlFor='extension' className="form-label fw-medium" >Second Alternate No.</label>
                                    <input type="text" className="form-control" name="alt_second" placeholder="Enter here..."
                                        value={form.alt_second}
                                        onChange={handleInputChange}
                                    />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="form-check mb-0">

                                   
                                                <div className="d-flex justify-content-between align-items-center">



                                                    <div className="form-check mb-0">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="phoneCheckbox"
                                                            checked={form.phoneChecked_two}
                                                            onChange={(e) => setForm({ ...form, phoneChecked_two: e.target.checked })}
                                                        />
                                                        <FaWhatsapp size={20} className='text-success' />
                                                        <label className="form-check-label small" htmlFor="phoneCheckbox">

                                                        </label>
                                                    </div>

                                                </div>
                                         
                                        </div>
                                    </div>
                                </div>

                                {/* Email ID */}
                                <div className="col-md-4">
                                    <label htmlFor='email' className="form-label fw-medium" >Email ID</label>
                                    <input type="text" className="form-control" name="email" placeholder="Enter here..." value={form.email} onChange={handleInputChange} required />
                                </div>
                                {/* DOB */}
                                <div className="col-md-4">
                                    <label htmlFor="dob" className="form-label fw-medium">DOB</label>
                                    <input type="date" className="form-control" name="dob"
                                        value={form.dob}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                {/* Confirmed On */}
                                <div className="col-md-4">
                                    <label htmlFor='confirmed' className="form-label fw-medium" >Confirmed On</label>
                                    <input type="text" className="form-control" name="confirmed" placeholder="Enter here..."
                                        value={form.confirmed}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                {/* Gender */}
                                <div className="col-md-4">
                                    <label htmlFor="gender" className="form-label fw-medium">Select Gender</label>

                                    <Select
                                        options={genderOptions}
                                        placeholder="Choose Title..."
                                        id="title"
                                        value={genderOptions.find(option => option.label === form.gender)} // finds the object by label
                                        onChange={(selectedOption) =>
                                            setForm({ ...form, gender: selectedOption.label }) // store label instead of value
                                        }
                                    />

                                </div>
                                {/* Status */}
                                <div className="col-md-4">
                                    <label htmlFor="status" className="form-label fw-medium">Select Status</label>

                                    <Select
                                        options={statusOptions}
                                        placeholder="Choose Title..."
                                        id="title"
                                        value={statusOptions.find(option => option.label === form.job_status)} // finds the object by label
                                        onChange={(selectedOption) =>
                                            setForm({ ...form, job_status: selectedOption.label })
                                        }
                                    />

                                </div>


                                <div className="col-md-4">
                                    <label htmlFor="designation" className="form-label fw-medium">Select Designation</label>
                                
                                    <Select
    options={[...designationOptions, { label: "➕ Add New Designation", value: "__add_new__" }]}
    placeholder="Choose Designation..."
    id="designation"
    name="designation"
    value={designationOptions.find(option => option.label === form.designation)}
    onChange={(selectedOption) => {
        if (selectedOption.value === "__add_new__") {
            setShowDesignationModal(true);
        } else {
            setForm({ ...form, designation: selectedOption.label });
        }
    }}
/>

                                </div>
                                {showDesignationModal && (
                                    <div className="modal show d-block" tabIndex="-1">
                                        <div className="modal-dialog">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Add New Designation</h5>
                                                    <button
                                                        type="button"
                                                        className="btn-close"
                                                        onClick={() => setShowDesignationModal(false)}
                                                    ></button>
                                                </div>
                                                <div className="modal-body">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter designation"
                                                        value={newDesignationName}
                                                        onChange={(e) => setNewDesignationName(e.target.value)}
                                                    />
                                                </div>
                                                <div className="modal-footer">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        onClick={() => {
                                                            setNewDesignationName("");
                                                            setShowDesignationModal(false);
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-success"
                                                        onClick={() => {
                                                            if (!newDesignationName.trim()) return;

                                                
                                                            setDesignationOptions([
                                                                ...designationOptions,
                                                                { label: newDesignationName, value: newDesignationName.toLowerCase().replace(/\s+/g, "_") },
                                                            ]);

                                                         
                                                            setForm({ ...form, designation: newDesignationName });

                               
                                                            setNewDesignationName("");
                                                            setShowDesignationModal(false);
                                                        }}
                                                    >
                                                        OK
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}


                                <div className="col-md-4">
                                    <label htmlFor="department" className="form-label fw-medium">
                                        Select Department
                                    </label>

                                    <Select
                                        options={departments.filter(option => roles.some(role => role.department === option.value &&
                                            Number(role.company_id) === Number(companyID || branches.find(branch => String(branch.id) === String(form.branch))?.company_id)))}
                                        placeholder="Choose department..."
                                        id="department"
                                        value={departments.find((opt) => opt.value === form.department) || null}
                                        onChange={(selectedOption) => {
                                            setSelectedRoleId('');
                                            setForm({ ...form, department: selectedOption?.value || '', role: '' });
                                        }}
                                    />
                                </div>


                                <div className="col-md-4">
                                    <label htmlFor="role" className="form-label fw-medium">
                                        Select Role
                                    </label>

                                    <Select
                                        options={roles.filter((r) => r.department === form.department &&
                                            Number(r.company_id) === Number(companyID || branches.find(branch => String(branch.id) === String(form.branch))?.company_id))}
                                        placeholder="Choose role..."
                                        id="role"
                                        value={roles.find((opt) => selectedRoleId ? String(opt.value) === String(selectedRoleId)
                                            : opt.roleText === form.role && opt.department === form.department) || null}
                                        onChange={(selectedOption) => {
                                            setSelectedRoleId(selectedOption ? String(selectedOption.value) : '');
                                            setForm({ ...form, role: selectedOption?.roleText || '' });
                                        }}
                                        isDisabled={!form.department} 
                                    />
                                </div>



                                <div className="col-md-4">
                                    <label htmlFor="role" className="form-label fw-medium">
                                        Branch
                                    </label>

                                    <select
                                        className="form-select"
                                        name="branch"
                                        value={form.branch || ""}
                                        onChange={(e) => setForm({ ...form, branch: e.target.value })}
                                    >
                                        <option value="">Select Branch</option>
                                        {branches.map((branch) => (
                                            <option key={branch.id} value={branch.id}>
                                                {branch.name}
                                            </option>
                                        ))}
                                    </select>


                                </div>


                                <div className="mt-4">
                                    <h5 className='mt-1 fs-4 text-center fw-semibold text-primary'>Address Detail</h5>
                                    <hr />

                                    <div className="row">
                                       <h4 className='fw-semibold text-success'>Present Address</h4>
                                        <div className='col-md-4 '>

                                         

                                            <div className="d-flex align-items-end gap-2">


                                                <div className='flex-grow-1 '>
                                                    <label>Pincode</label>


                                                    <input
                                                        type='number'
                                                        className='form-control'
                                                        name='pin'
                                                        value={form.pin}
                                                        placeholder='Pincode'
                                                        onChange={handleInputChange}

                                                        required
                                                    />
                                                </div>

                                                <button className='btn btn-primary'
                                                    type="button"
                                                    onClick={handlePincodeCheck}
                                                >OK </button>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <label className="form-label fw-medium">State</label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                name="state"
                                                value={form.state}
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <label className="form-label fw-medium">City</label>


                                            <input
                                                type="text"
                                                className="form-control"
                                                name="city"
                                                value={form.city}
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <label className="form-label fw-medium">Region</label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                name="region"
                                                value={form.region}
                                                readOnly
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label fw-medium">Address</label>
                                            <textarea
                                                className="form-control"
                                                name="address"
                                                placeholder="Enter here..."
                                                value={form.address}
                                                onChange={handleInputChange}
                                                rows={4}
                                            />
                                        </div>


                                    </div>




                                     <div className="row">
                                       <h4 className='fw-semibold text-success mt-3'>Permanent Address</h4>
                                        <div className='col-md-4 '>

                                         

                                            <div className="d-flex align-items-end gap-2">


                                                <div className='flex-grow-1 '>
                                                    <label>Pincode</label>


                                                    <input
                                                        type='number'
                                                        className='form-control'
                                                        name='pincode_two'
                                                        value={form.pincode_two}
                                                        placeholder='Pincode'
                                                        onChange={handleInputChange}

                                                        required
                                                    />
                                                </div>

                                                <button className='btn btn-primary'
                                                    type="button"
                                                    onClick={handlePincodeCheckParmanent}
                                                >OK </button>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <label className="form-label fw-medium">State</label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                name="state_two"
                                                value={form.state_two}
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <label className="form-label fw-medium">City</label>


                                            <input
                                                type="text"
                                                className="form-control"
                                                name="city_two"
                                                value={form.city_two}
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <label className="form-label fw-medium">Region</label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                name="region_two"
                                                value={form.region_two}
                                                readOnly
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label fw-medium">Address</label>
                                            <textarea
                                                className="form-control"
                                                name="address_two"
                                                placeholder="Enter here..."
                                                value={form.address_two}
                                                onChange={handleInputChange}
                                                rows={4}
                                            />
                                        </div>


                                    </div>
                                </div>

                                <h5 className="mt-4 fs-4 text-center fw-semibold text-primary">Education & Experience</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="table-responsive my-4">

                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5>Experience</h5>
                                            <Button variant="success" size="sm" onClick={handleAddRow}>
                                                ➕ Add
                                            </Button>
                                        </div>


                                        <Table bordered responsive className="text-center align-middle">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th>Employer</th>
                                                    <th>Designation</th>
                                                    <th>DOJ</th>
                                                    <th>Left On</th>
                                                    <th>Joining Salary</th>
                                                    <th>Last Salary</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {rows.length > 0 ? (
                                                    rows.map((row, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={row.employer}
                                                                    onChange={(e) =>
                                                                        handleChange(index, "employer", e.target.value)
                                                                    }
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={row.designation}
                                                                    onChange={(e) =>
                                                                        handleChange(index, "designation", e.target.value)
                                                                    }
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    value={row.doj}
                                                                    onChange={(e) => handleChange(index, "doj", e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    value={row.leftOn}
                                                                    onChange={(e) =>
                                                                        handleChange(index, "leftOn", e.target.value)
                                                                    }
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={row.joiningSalary}
                                                                    onChange={(e) =>
                                                                        handleChange(index, "joiningSalary", e.target.value)
                                                                    }
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={row.lastSalary}
                                                                    onChange={(e) =>
                                                                        handleChange(index, "lastSalary", e.target.value)
                                                                    }
                                                                />
                                                            </td>
                                                            <td>
                                                                <Button
                                                                    variant="danger"
                                                                    size="sm"
                                                                    onClick={() => handleDeleteRow(index)}
                                                                >
                                                                    🗑️ Delete
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" className="text-muted">
                                                            No rows added yet.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>

                                    </div>



                                    <div className="table-responsive my-4">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5>Education Details</h5>
                                            <Button variant="success" size="sm" onClick={handleAddEducationRow}>
                                                ➕ Add
                                            </Button>
                                        </div>

                                        <Table bordered responsive className="text-center align-middle">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th>Exam</th>
                                                    <th>Board / University</th>
                                                    <th>Passing Year</th>
                                                    <th>Percentage</th>
                                                    <th>Certificate Upload</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {educationRows.length > 0 ? (
                                                    educationRows.map((row, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={row.exam}
                                                                    onChange={(e) =>
                                                                        handleEducationChange(index, "exam", e.target.value)
                                                                    }
                                                                    placeholder="e.g. 10th / 12th / BSc"
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={row.board}
                                                                    onChange={(e) =>
                                                                        handleEducationChange(index, "board", e.target.value)
                                                                    }
                                                                    placeholder="e.g. CBSE / Mumbai Univ."
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={row.passingYear}
                                                                    onChange={(e) =>
                                                                        handleEducationChange(index, "passingYear", e.target.value)
                                                                    }
                                                                    placeholder="e.g. 2022"
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={row.percentage}
                                                                    onChange={(e) =>
                                                                        handleEducationChange(index, "percentage", e.target.value)
                                                                    }
                                                                    placeholder="e.g. 85"
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="file"
                                                                    className="form-control"
                                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                                    onChange={(e) =>
                                                                        handleFileRowChange(index, e.target.files[0])
                                                                    }
                                                                />

                                                                {row.certificate && typeof row.certificate === 'string' && (
                                                                    <span>{row.certificate.split('/').pop()}</span>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <Button
                                                                    variant="danger"
                                                                    size="sm"
                                                                    onClick={() => handleDeleteEducationRow(index)}
                                                                >
                                                                    🗑️ Delete
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-muted">
                                                            No education records added yet.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>


                                </div>






                                <h5 className="mt-4 fs-4 text-center fw-semibold text-primary">Bank & ESIC Details</h5>
                                <hr />
                                <div className="row g-3">
                                    {/* Bank Name */}
                                    <div className="col-md-4">
                                        <label htmlFor="bank_name" className="form-label fw-medium">Bank Name</label>
                                        <input type="text" className="form-control" name="bank_name" placeholder="Enter here..." value={form.bank_name} onChange={handleInputChange} />
                                    </div>
                                    {/* Bank A/c */}
                                    <div className="col-md-4">
                                        <label htmlFor="acc_no" className="form-label fw-medium">Bank A/c</label>
                                        <input type="number" className="form-control" name="bank_acc" placeholder="Enter here..." value={form.bank_acc} onChange={handleInputChange} />
                                    </div>
                                    {/* Bank Branch */}
                                    <div className="col-md-4">
                                        <label htmlFor="branch" className="form-label fw-medium">Bank Branch</label>
                                        <input type="text" className="form-control" name="bank_branch" placeholder="Enter here..." value={form.bank_branch} onChange={handleInputChange} />
                                    </div>
                                    {/* Bank IFSC */}
                                    <div className="col-md-4">
                                        <label htmlFor="ifsc" className="form-label fw-medium">Bank IFSC</label>
                                        <input type="text" className="form-control" name="ifsc" placeholder="IFSC" value={form.ifsc} onChange={handleInputChange} />
                                    </div>
                                    {/* ESIC Number */}
                                    <div className="col-md-4">
                                        <label htmlFor="esic_no" className="form-label fw-medium">ESIC Number</label>
                                        <input type="text" className="form-control" name="esic" placeholder="ESIC Number" value={form.esic} onChange={handleInputChange} />
                                    </div>
                                </div>


                                <h5 className="mt-4 fs-4 text-center fw-semibold text-primary">Other Details</h5>
                                <hr />


                                <div className="table-responsive my-2">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h5> Member Details</h5>
                                        <Button variant="success" size="sm" onClick={handleAddMemberRow}>
                                            ➕ Add Member
                                        </Button>
                                    </div>

                                    <Table bordered responsive className="text-center align-middle">
                                        <thead className="table-primary">
                                            <tr>
                                                <th>Name</th>
                                                <th>Relation</th>
                                                <th>Contact No</th>
                                                <th>Work</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {members.length > 0 ? (
                                                members.map((member, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={member.name}
                                                                onChange={(e) =>
                                                                    handleMemberChange(index, "name", e.target.value)
                                                                }
                                                                placeholder="Enter name"
                                                            />
                                                        </td>
                                                        <td>
                                                            <select
                                                                className="form-control"
                                                                value={member.relation}
                                                                onChange={(e) =>
                                                                    handleMemberChange(index, "relation", e.target.value)
                                                                }
                                                            >
                                                                <option value="">-- Select Relation --</option>
                                                                <option value="Father">Father</option>
                                                                <option value="Mother">Mother</option>
                                                                <option value="Brother">Brother</option>
                                                                <option value="Sister">Sister</option>
                                                                <option value="Spouse">Spouse</option>
                                                                <option value="Son">Son</option>
                                                                <option value="Daughter">Daughter</option>
                                                                <option value="Other">Other</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="tel"
                                                                className="form-control"
                                                                value={member.contact}
                                                                onChange={(e) =>
                                                                    handleMemberChange(index, "contact", e.target.value)
                                                                }
                                                                placeholder="e.g. 9876543210"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={member.work}
                                                                onChange={(e) =>
                                                                    handleMemberChange(index, "work", e.target.value)
                                                                }
                                                                placeholder="e.g. Teacher, Engineer"
                                                            />
                                                        </td>
                                                        <td>
                                                            <Button
                                                                variant="danger"
                                                                size="sm"
                                                                onClick={() => handleDeleteMemberRow(index)}
                                                            >
                                                                🗑️ Delete
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-muted">
                                                        No member records added yet.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>


                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label htmlFor="bank_name" className="form-label fw-medium">Medical Info Current Medication</label>
                                        <input type="text" className="form-control" name="medical_info" placeholder="Enter here..." value={form.medical_info} onChange={handleInputChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="bank_name" className="form-label fw-medium">Medical Condition</label>
                                        <input type="text" className="form-control" name="medical_condition" placeholder="Enter here..." value={form.medical_condition}
                                            onChange={handleInputChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="bank_name" className="form-label fw-medium">Blood Group</label>
                                        <select
                                            className="form-control"
                                            name="blood_grp"
                                            value={form.blood_grp}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">-- Select Relation --</option>
                                            <option value="A+">A+</option>
                                            <option value="A-">A-</option>
                                            <option value="B+">B+</option>
                                            <option value="B-">B-</option>
                                            <option value="O+">O+</option>
                                            <option value="O-">O-</option>

                                        </select>
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="bank_name" className="form-label fw-medium">Alergies</label>
                                        <input type="text" className="form-control" name="alergies" placeholder="Enter here..." value={form.alergies} onChange={handleInputChange} />
                                    </div>




                                    <div className="col-md-4">
                                        <label htmlFor='img' className="form-label fw-medium" > Upload Photo</label>



                                        {isEditMode && files.file && typeof files.file === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.file}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.file}
                                                </a>
                                            </div>
                                        )}
                                        <input type="file" className="form-control" name="file" accept="image/*,application/pdf"
                                            //  onChange={handleFileChange} 
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                setFiles({ ...files, file });
                                            }}
                                        />
                                    </div>
                                    {/* Reporting To */}

                                    <div className="col-md-4">
                                        <label htmlFor="reporting" className="form-label fw-medium">Reporting To</label>


                                        <Select
    options={[
        ...reportingOptions,
        { label: "➕ Add New Reporting Title", value: "__add_new_reporting__" }
    ]}
    placeholder="Choose Title..."
    id="reporting"
    value={reportingOptions.find(option => option.label === form.reporting)}
    onChange={(selectedOption) => {
        if (selectedOption.value === "__add_new_reporting__") {
            setShowReportingModal(true);
        } else {
            setForm({ ...form, reporting: selectedOption.label });
        }
    }}
/>



                                    </div>

                                    {showReportingModal && (
    <div className="modal show d-block" tabIndex="-1">
        <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Add New Reporting Title</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowReportingModal(false)}
                    ></button>
                </div>

                <div className="modal-body">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter reporting title"
                        value={newReportingName}
                        onChange={(e) => setNewReportingName(e.target.value)}
                    />
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                            setNewReportingName("");
                            setShowReportingModal(false);
                        }}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => {
                            if (!newReportingName.trim()) return;

                            // Add to dropdown
                            setReportingOptions([
                                ...reportingOptions,
                                {
                                    label: newReportingName,
                                    value: newReportingName.toLowerCase().replace(/\s+/g, "_"),
                                },
                            ]);

                            // Update form
                            setForm({ ...form, reporting: newReportingName });

                            // Reset
                            setNewReportingName("");
                            setShowReportingModal(false);
                        }}
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    </div>
)}



                                    {/* Weekly Off */}
                                    <div className="col-md-4">
                                        <label htmlFor="off" className="form-label fw-medium">Weekly Off</label>


                                        <Select
                                            options={weekOptions}
                                            placeholder="Choose Title..."
                                            id="title"
                                            value={weekOptions.find(option => option.label === form.weekly_off)} 
                                            onChange={(selectedOption) =>
                                                setForm({ ...form, weekly_off: selectedOption.label }) 
                                            }
                                        />

                                    </div>
                                    {/* Basic */}
                                    <div className="col-md-4">
                                        <label htmlFor='basic' className="form-label fw-medium" >Basic</label>
                                        <input type="number" className="form-control" name="basic" placeholder="Enter here..."

                                            value={form.basic}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    {/* marital Status */}
                                    <div className="col-md-4">
                                        <label htmlFor="marital" className="form-label fw-medium">Marital Status</label>

                                        <Select
                                            options={maritalOptions}
                                            placeholder="Choose Title..."
                                            id="title"
                                            value={maritalOptions.find(option => option.label === form.marital_status)} 
                                            onChange={(selectedOption) =>
                                                setForm({ ...form, marital_status: selectedOption.label }) 
                                            }
                                        />

                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="doj" className="form-label fw-medium">DOJ</label>
                                        <input type="date" className="form-control" name="doj"
                                            value={form.doj}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {/* Separation date */}
                                    <div className="col-md-4">
                                        <label htmlFor="separation" className="form-label fw-medium">Separation Date</label>
                                        <input type="date" className="form-control" name="seperation_date"
                                            value={form.seperation_date}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {/* pf_no No. */}
                                    <div className="col-md-4">
                                        <label htmlFor='pf_no' className="form-label fw-medium" >PF No.</label>
                                        <input type="number" className="form-control" name="pf_no" placeholder="Enter here..."
                                            value={form.pf_no}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor='pf_no' className="form-label fw-medium" >LIC No.</label>
                                        <input type="number" className="form-control" name="lic" placeholder="Enter here..."
                                            value={form.lic}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor='pf_no' className="form-label fw-medium" >Health Mediclaim No.</label>
                                        <input type="number" className="form-control" name="mediclaim_no" placeholder="Enter here..."
                                            value={form.mediclaim_no}
                                            onChange={handleInputChange}
                                        />
                                    </div>


                                    <div className="col-md-4">
                                        <label htmlFor="aadhaar" className="form-label fw-medium">Upload Aadhaar</label>

                                        {isEditMode && files.aadhaar && typeof files.aadhaar === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.aadhaar}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.aadhaar}
                                                </a>
                                            </div>
                                        )}

                                        <input
                                            type="file"
                                            className="form-control"
                                            name="aadhaar"
                                            accept="application/pdf"

                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file && file.type !== "application/pdf") {
                                                    showToast("Please select a PDF file only!", "danger");
                                                    e.target.value = "";
                                                    return;
                                                }

                                                // save the new file in form state
                                                setForm({ ...form, aadhaar: file });

                                                // update preview so user sees new file immediately
                                                if (file) {
                                                    setPreviews({ ...previews, aadhaar: URL.createObjectURL(file) });
                                                }

                                                handleFileChange(e);
                                            }}
                                        />
                                    </div>


                                    <div className="col-md-4">
                                        <label htmlFor='img' className="form-label fw-medium" > Upload Pan</label>


                                        {isEditMode && files.pan && typeof files.pan === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.pan}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.pan}
                                                </a>
                                            </div>
                                        )}

                                        <input
                                            type="file"
                                            className="form-control"
                                            name="pan"
                                            accept="application/pdf"

                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file && file.type !== "application/pdf") {
                                                    showToast("Please select a PDF file only!", "danger");
                                                    e.target.value = ""; // clear invalid file
                                                    return;
                                                }


                                                setForm({ ...form, pan: file });


                                                if (file) {
                                                    setPreviews({ ...previews, pan: URL.createObjectURL(file) });
                                                }

                                                handleFileChange(e); // optional: still call your existing function
                                            }}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor='img' className="form-label fw-medium" > Upload Light Bill</label>


                                        {isEditMode && files.light_bill && typeof files.light_bill === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.light_bill}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.light_bill}
                                                </a>
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            className="form-control"
                                            name="light_bill"
                                            accept="application/pdf"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file && file.type !== "application/pdf") {
                                                    showToast("Please select a PDF file only!", "danger");
                                                    e.target.value = "";
                                                    return;
                                                }

                                                setForm({ ...form, light_bill: file });
                                                if (file) setPreviews({ ...previews, light_bill: URL.createObjectURL(file) });
                                                handleFileChange(e);
                                            }}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor='img' className="form-label fw-medium" > Upload 10th Marksheet</label>


                                        {isEditMode && files.tenth_mark && typeof files.tenth_mark === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.tenth_mark}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.tenth_mark}
                                                </a>
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            className="form-control"
                                            name="tenth_mark"
                                            accept="application/pdf"

                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file && file.type !== "application/pdf") {
                                                    showToast("Please select a PDF file only!", "danger");
                                                    e.target.value = "";
                                                    return;
                                                }

                                                setForm({ ...form, tenth_mark: file });
                                                if (file) setPreviews({ ...previews, tenth_mark: URL.createObjectURL(file) });
                                                handleFileChange(e);
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor='img' className="form-label fw-medium" > Upload 12th Marksheet</label>


                                        {isEditMode && files.twelth_mark && typeof files.twelth_mark === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.twelth_mark}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.twelth_mark}
                                                </a>
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            className="form-control"
                                            name="twelth_mark"
                                            accept="application/pdf"


                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file && file.type !== "application/pdf") {
                                                    showToast("Please select a PDF file only!", "danger");
                                                    e.target.value = "";
                                                    return;
                                                }

                                                setForm({ ...form, twelth_mark: file });
                                                if (file) setPreviews({ ...previews, twelth_mark: URL.createObjectURL(file) });
                                                handleFileChange(e);
                                            }}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor='img' className="form-label fw-medium" > Upload other Document</label>


                                        {isEditMode && files.other_doc && typeof files.other_doc === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.other_doc}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.other_doc}
                                                </a>
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            className="form-control"
                                            name="other_doc"
                                            accept="application/pdf"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file && file.type !== "application/pdf") {
                                                    showToast("Please select a PDF file only!", "danger");
                                                    e.target.value = "";
                                                    return;
                                                }

                                                setForm({ ...form, other_doc: file });
                                                if (file) setPreviews({ ...previews, other_doc: URL.createObjectURL(file) });
                                                handleFileChange(e);
                                            }}
                                        />
                                    </div>

                                </div>


                               

                                <div className='gap-2 d-flex justify-content-center mt-4'>
                                    <button type="submit" className='btn btn-success w-10'>
                                        {isEditMode ? "Update" : "Save"}
                                    </button>
                                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                        setShowForm(false);
                                        setIsEditMode(false);
                                        setSelectedRoleId('');
                                        setForm({
                                            title: '', first: '', middle: '', last: '',
                                            emp_id: '', emp_code: '', phone: '', extension: '',
                                            email: '', dob: '', confirmed: '', gender: '', job_status: '',
                                            designation: '', department: '', address: '', city: '',
                                            pin: '', state: '', bank_name: '', bank_acc: '', bank_branch: '',
                                            ifsc: '', esic: '', reporting: '', weekly_off: '', basic: '',
                                            marital_status: '', doj: '', seperation_date: '', pf_no: '',
                                            role: '', region: '', alt_first: '', alt_second: '',
                                            lic: '', mediclaim_no: '',pincode_two:'', state_two:'', city_two:'',  region_two:'', address_two:'',
                                        });
                                        setRows([]);
                                        setMembers([]);
                                        setEducationRows([]);
                                    }}>
                                        Cancel
                                    </button>
                                </div>

                            </div>
                        </form>
                    </div>
                )}
                {/* main-table */}
                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className='table table-bordered table-striped table-hover text-center align-middle'>
                        <thead className='table-info'>
                            <tr>
                                <th scope='col'>SN</th>
                                   <th scope='col'>Action</th>
                                <th scope='col'>Full Name</th>
                                {/* <th scope='col'>Email</th> */}
                                <th scope='col'>Phone</th>
                                <th scope='col'>Designation</th>

                                <th scope='col'>Emp ID</th>
                                <th scope='col'>Emp Code </th>
                             
                            </tr>
                        </thead>
                        <tbody>
                            {filterUser.map((emp, idx) => (
                                <tr key={idx}>
                                    <td>{idx + 1}</td>
                                         <td>
                                    
                                        <button type="button"
                                            className='btn btn-success mx-2'
                                            onClick={() => downloadAll(emp.id, emp.first, emp.last)}
                                        >
                                            <IoMdDownload size={20} title='Download' />

                                        </button>


                                        <button type="button"
                                            className='btn btn-primary mx-2'
                                            onClick={() => handleEdit(emp)}

                                        >

                                            <AiOutlineEdit size={20} title='Edit' />
                                        </button>

                                        <button
                                            className="btn btn-danger"
                                            onClick={() => {
                                                setSelectedEmp(emp); 
                                                setShowConfirm(true);
                                            }}
                                        >
                                            <AiOutlineDelete size={20} title='Delete' />
                                        </button >

                                        <button  type='button'  className="btn btn-warning mx-2"   onClick={() => {
        setCurrentEmp(emp);         
        setShowPasswordModal(true);  
    }}  > <TbPasswordUser title='Reset Password' /> </button>
                                    </td>
                                    <td>{emp.first} {emp.middle} {emp.last} </td>
                                    {/* <td>{emp.email}</td> */}
                                    <td> {emp.phone} </td>
                                    <td>{emp.designation}</td>
                                    <td>{emp.emp_id}</td>
                                    <td> {emp.emp_code} </td>
                               
                                </tr>



                            ))}


                            {showConfirm && selectedEmp && (
                                <div className="modal d-block" tabIndex="-1">
                                    <div className="modal-dialog">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">Confirm Delete</h5>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={() => setShowConfirm(false)}
                                                ></button>
                                            </div>
                                            <div className="modal-body">
                                                <p>
                                                    Are you sure you want to delete employee{" "}
                                                    <strong>{selectedEmp.name}</strong>?
                                                </p>
                                            </div>
                                            <div className="modal-footer">
                                                <button
                                                    className="btn btn-secondary"
                                                    onClick={() => setShowConfirm(false)}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    className="btn btn-danger"
                                                    onClick={() => {
                                                        handleDeleteEmployee(selectedEmp.id); 
                                                        setShowConfirm(false);
                                                        setSelectedEmp(null);
                                                    }}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}


                            {filterUser.length === 0 && (
                                <tr>
                                    <td colSpan="6" className='text-center text-muted'>
                                        No records found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>




                {showModal && (
                    <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title>Employee Details</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            {/* Hidden section for PDF generation */}
                            <div id="print-section" style={{ padding: "20px" }}>

                                <Row className="mb-3">
                                    <Col md={4} className="text-center">
                                        {selectedEmp?.photo ? (
                                            <img
                                                src={`https://api.skyguard.group/uploads/${selectedEmp.photo}`}
                                                alt="Passport"
                                                className="img-fluid rounded"
                                                style={{ maxHeight: "200px" }}
                                            />
                                        ) : (
                                            <div className="border p-4">No Photo</div>
                                        )}
                                    </Col>
                                    <Col md={8}>
                                        <Table bordered size="sm">


                                            <tbody>
                                                <tr>
                                                    <th>Title</th>
                                                    <td>{selectedEmp?.title}</td>
                                                </tr>
                                                <tr>
                                                    <th>First Name</th>
                                                    <td>{selectedEmp?.first}</td>
                                                </tr>
                                                <tr>
                                                    <th>Middle Name</th>
                                                    <td>{selectedEmp?.middle}</td>
                                                </tr>
                                                <tr>
                                                    <th>Last Name</th>
                                                    <td>{selectedEmp?.last}</td>
                                                </tr>
                                                <tr>
                                                    <th>Employee ID</th>
                                                    <td>{selectedEmp?.emp_id}</td>
                                                </tr>
                                                <tr>
                                                    <th>Employee Code</th>
                                                    <td>{selectedEmp?.emp_code}</td>
                                                </tr>

                                                <tr>
                                                    <th>Email</th>
                                                    <td>{selectedEmp?.email}</td>
                                                </tr>
                                                <tr>
                                                    <th>Phone</th>
                                                    <td>{selectedEmp?.phone}</td>
                                                </tr>
                                                <tr>
                                                    <th>Date of Birth</th>
                                                    <td>{selectedEmp?.dob}</td>
                                                </tr>
                                                <tr>
                                                    <th>Gender</th>
                                                    <td>{selectedEmp?.gender}</td>
                                                </tr>
                                                <tr>
                                                    <th>Confirmed</th>
                                                    <td>{selectedEmp?.confirmed}</td>
                                                </tr>
                                                <tr>
                                                    <th>Job Status</th>
                                                    <td>{selectedEmp?.job_status}</td>
                                                </tr>
                                                <tr>
                                                    <th>Designation</th>
                                                    <td>{selectedEmp?.designation}</td>
                                                </tr>
                                                <tr>
                                                    <th>Department</th>
                                                    <td>{selectedEmp?.department}</td>
                                                </tr>
                                                <tr>
                                                    <th>Address</th>
                                                    <td>{`${selectedEmp?.address}, ${selectedEmp?.city}, ${selectedEmp?.state} - ${selectedEmp?.pin}`}</td>
                                                </tr>
                                                <tr>
                                                    <th>Bank Name</th>
                                                    <td>{selectedEmp?.bank_name}</td>
                                                </tr>
                                                <tr>
                                                    <th>Bank Account</th>
                                                    <td>{selectedEmp?.bank_acc}</td>
                                                </tr>
                                                <tr>
                                                    <th>Bank Branch</th>
                                                    <td>{selectedEmp?.bank_branch}</td>
                                                </tr>
                                                <tr>
                                                    <th>IFSC</th>
                                                    <td>{selectedEmp?.ifsc}</td>
                                                </tr>
                                                <tr>
                                                    <th>ESIC</th>
                                                    <td>{selectedEmp?.esic}</td>
                                                </tr>
                                                <tr>
                                                    <th>Reporting</th>
                                                    <td>{selectedEmp?.reporting}</td>
                                                </tr>
                                                <tr>
                                                    <th>Weekly Off</th>
                                                    <td>{selectedEmp?.weekly_off}</td>
                                                </tr>
                                                <tr>
                                                    <th>Basic</th>
                                                    <td>{selectedEmp?.basic}</td>
                                                </tr>
                                                <tr>
                                                    <th>Marital Status</th>
                                                    <td>{selectedEmp?.marital_status}</td>
                                                </tr>
                                                <tr>
                                                    <th>Date of Joining</th>
                                                    <td>{selectedEmp?.doj}</td>
                                                </tr>
                                                <tr>
                                                    <th>Separation Date</th>
                                                    <td>{selectedEmp?.seperation_date}</td>
                                                </tr>
                                                <tr>
                                                    <th>PF No.</th>
                                                    <td>{selectedEmp?.pf_no}</td>
                                                </tr>
                                                <tr>
                                                    <th>Alternate First</th>
                                                    <td>{selectedEmp?.alt_first}</td>
                                                </tr>
                                                <tr>
                                                    <th>Alternate Second</th>
                                                    <td>{selectedEmp?.alt_second}</td>
                                                </tr>
                                                <tr>
                                                    <th>Region</th>
                                                    <td>{selectedEmp?.region}</td>
                                                </tr>
                                                <tr>
                                                    <th>LIC</th>
                                                    <td>{selectedEmp?.lic}</td>
                                                </tr>
                                                <tr>
                                                    <th>Mediclaim No.</th>
                                                    <td>{selectedEmp?.mediclaim_no}</td>
                                                </tr>
                                                <tr>
                                                    <th>Role</th>
                                                    <td>{selectedEmp?.role}</td>
                                                </tr>
                                            </tbody>


                                        </Table>
                                    </Col>
                                </Row>


                                <h5>Documents</h5>
                                {documents.map(
                                    (doc, idx) =>
                                        doc.file && (
                                            <div key={idx} className="mb-3">
                                                <p><strong>{doc.label}</strong></p>
                                                {doc.file.endsWith(".pdf") ? (
                                                    <iframe
                                                        src={`https://api.skyguard.group/uploads/${doc.file}`}
                                                        type="application/pdf"
                                                        className="w-100 border"
                                                        style={{ height: "120vh" }}
                                                    ></iframe>
                                                ) : (
                                                    <img
                                                        src={`https://api.skyguard.group/uploads/${doc.file}`}
                                                        alt={doc.label}
                                                        className="img-fluid border"
                                                        style={{ maxHeight: "400px" }}
                                                    />
                                                )}
                                            </div>
                                        )
                                )}


                            </div>



                        </Modal.Body>

                        <Modal.Footer>
                            {page === 2 && (
                                <Button variant="secondary" onClick={() => setPage(1)}>
                                    Back
                                </Button>
                            )}
                            {page === 1 && (
                                <Button variant="secondary" onClick={() => setPage(2)}>
                                    Next
                                </Button>
                            )}

                            <Button variant="success" size="sm" onClick={downloadAll}>
                                Download All
                            </Button>

                            <Button variant="danger" onClick={() => setShowModal(false)}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}


<div
  className={`modal fade ${showPasswordModal ? "show d-block" : ""}`}
  tabIndex="-1"
  aria-hidden={!showPasswordModal}
  onClick={() => setShowPasswordModal(false)} 
>
  <div
    className="modal-dialog modal-dialog-centered"
    onClick={(e) => e.stopPropagation()} 
  >
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Enter New Password</h5>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => setShowPasswordModal(false)}
        ></button>
      </div>

      <div className="modal-body">
        <input
          type="password"
          className="form-control"
          value={enteredPassword}
          onChange={(e) => setEnteredPassword(e.target.value)}
          placeholder="New Password"
        />
      </div>

      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => {
            setShowPasswordModal(false);
            setEnteredPassword("");
            setCurrentEmp(null);
          }}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleUpdatePassword}
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>

            </div>
        </div>

    )
}

export default AddEmployee
